/**
 * Status Badge Component
 * Styled badge for deal status display
 */

import React from 'react';
import { Badge } from '../ui/badge';
import { getStatusConfig } from '../../utils/formatters';
import { cn } from '../../lib/utils';

export const StatusBadge = ({ status, className }) => {
  const config = getStatusConfig(status);

  return (
    <Badge 
      variant="secondary"
      className={cn(config.color, className)}
    >
      {config.label}
    </Badge>
  );
};

export default StatusBadge;
